export enum ValidationMethod {
	CustomRules,
	// Some future ideas
	// Schema,
	// AISchema,
}
